import {createAction, createAsyncThunk} from '@reduxjs/toolkit'

import {isEqualDay} from '@shared/helpers/date'
import {isEmpty} from '@shared/helpers/lang'

import {isHopeSellerGuarantee} from '@web/helpers/policies'

import {OrderSheetProductsState, RootState} from './interfaces'

export const updateHopeDate = createAction<{
    orderSheetProductIds: string[]
    selectedDate: string
}>('orderSheetProducts/updateHopeDate')

export const overwriteHopeDate = createAsyncThunk<
    {
        orderSheetProductIds: string[]
    },
    void,
    {state: RootState}
>('orderSheetProducts/overwriteHopeDate', (_, {getState, rejectWithValue}) => {
    const {orderSheetProducts} = getState()
    const replaceDateProduct = orderSheetProducts.reduce<OrderSheetProductsState>((acc, product) => {
        const {arrivalGuaranteeDateTime, deliveryInfo} = product
        const {hopeDeliveryDate, hopeDeliveryTime} = deliveryInfo.hopeDelivery ?? {}
        const hopeDate =
            hopeDeliveryDate && hopeDeliveryTime ? `${hopeDeliveryDate} ${hopeDeliveryTime}`.replaceAll('-', '/') : ''
        if (
            isHopeSellerGuarantee(deliveryInfo.deliveryAttributeType) &&
            arrivalGuaranteeDateTime &&
            !isEqualDay(arrivalGuaranteeDateTime, hopeDate)
        ) {
            return [...(acc ?? []), product]
        }
        return acc
    }, [])

    if (isEmpty(replaceDateProduct)) {
        return rejectWithValue('REPLACE_DATE_PRODUCT_EMPTY')
    }

    const orderSheetProductIds = replaceDateProduct.map((product) => product.id)

    return {
        orderSheetProductIds,
    }
})
